"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTd = exports.StyledTh = exports.StyledTr = exports.StyledInformationContainer = exports.AttributeTable = exports.StyledSpan = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const canvas_box_1 = require("../canvas-box");
const themed_text_1 = require("../themed-text");
const setOverviewStyles = (0, styled_components_1.css) `
  padding: 10px 0px 0px 3px;
  width: 75%;
`;
exports.StyledSpan = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  text-align: left;
  vertical-align: top;
  padding-top: 0;
  ${setOverviewStyles}
`;
exports.AttributeTable = styled_components_1.default.table `
  align: left;
  border-top: 1px solid ${monera_app_core_1.Gray_1000};
  border-bottom: 1px solid ${monera_app_core_1.Gray_1000};
  grid-row-end: 4;
  table-layout: fixed;
  width: 50%;
`;
exports.StyledInformationContainer = (0, styled_components_1.default)(canvas_box_1.CanvasContainer) `
  width: fit-content;
`;
exports.StyledTr = styled_components_1.default.tr `
  border-top: 1px solid ${monera_app_core_1.Gray_1000};
  border-bottom: 1px solid ${monera_app_core_1.Gray_1000};
`;
exports.StyledTh = styled_components_1.default.th `
  background-color: ${monera_app_core_1.Gray_1400};
  white-space: normal;
  word-wrap: break-word;
  border-collapse: separate;
  padding-top: 0px;
  padding-bottom: 20px !important;
  vertical-align: top;
  width: 50%;
`;
exports.StyledTd = styled_components_1.default.td `
  border-collapse: separate;
  padding-top: 0px;
  padding-bottom: 20px !important;
`;
